export default __webpack_public_path__ + "static/media/LinkedIn.8815382d.svg";